import { Link } from 'react-router-dom';

import GmnLogo from '/gmn-logo.svg';

export const Logo = () => (
  <Link to="/" className="flex gap-2 items-center p-2 group/logo">
    <div className="flex justify-center items-center size-8 shrink-0 text-primary-foreground">
      <img src={GmnLogo} alt="GMN Logo" className="h-6 w-auto" />
    </div>
    <div className="grid text-left text-sm leading-tight group-data-[collapsible=icon]/sidebar:hidden">
      <span className="font-semibold">GMN</span>
      <span className="text-xs text-muted-foreground">Portal</span>
    </div>
  </Link>
);
